export enum EDevicesTagType {
  DEVICES = 'devices',
}
